import { render, staticRenderFns } from "./PeachPaymentsCallback.vue?vue&type=template&id=688eb418&scoped=true"
import script from "./PeachPaymentsCallback.vue?vue&type=script&lang=js"
export * from "./PeachPaymentsCallback.vue?vue&type=script&lang=js"
import style0 from "./PeachPaymentsCallback.vue?vue&type=style&index=0&id=688eb418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688eb418",
  null
  
)

export default component.exports